import { render, staticRenderFns } from "./confirmDLG.vue?vue&type=template&id=ced1afc8&scoped=true"
import script from "./confirmDLG.vue?vue&type=script&lang=ts"
export * from "./confirmDLG.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./confirmDLG.vue?vue&type=style&index=0&id=ced1afc8&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "ced1afc8",
  "2f5c092d"
  
)

export default component.exports